import React from 'react';
import Heading from '@codedrop/typography/esm/heading';
export const styleClasses = ['text', 'hero'];
export const titleTags = ['h1', 'h2', 'h3', 'h4'];

const Block = ({
  title,
  subtitle,
  children,
  modifier = 'text'
}) => /*#__PURE__*/React.createElement("div", {
  className: "block block--".concat(modifier)
}, title && /*#__PURE__*/React.createElement(Heading, {
  tag: title.tag,
  headingClass: "block__title"
}, title.text), subtitle && /*#__PURE__*/React.createElement(Heading, {
  tag: subtitle.tag,
  headingClass: "block__subtitle"
}, subtitle.highlight && /*#__PURE__*/React.createElement("b", null, subtitle.highlight, " "), subtitle.text), children);

Block.displayName = 'Block';
Block.defaultProps = {
  title: {
    tag: 'h2'
  },
  subtitle: {
    tag: 'h3'
  }
};
export default Block;